import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import { getAboutUsHeader } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";
import { isAllValuesEmpty } from "../../../Utills/objectUtils";
export default function HeaderView() {
  const { id,partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  const [title, setTitle] = useState({
    paragraph: ''
  });

  useEffect(() => {
    fetchTitle();
  }, [id]);

  const fetchTitle = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    try {
      const res = await getAboutUsHeader(id);
      const HeaderData = res.data.data[0];
      setTitle({ ...title, ...HeaderData, index: res.data.data.indexOf(HeaderData) });
    } catch (error) {
     showToast({
      type: 'error',
      message: error.response.data.message || 'Failed to fetch header. Please try again.',
     });
    } finally {
      setIsLoading(false); // Stop spinner
    }
  };

  const columns = ["Part Name", "Content"];
  const rows = [];

  if (title && Object.keys(title).length > 0 && !isAllValuesEmpty(title)) {
    rows.push(["Header Topic", title.paragraph]);
  }

  return (
 <>
    {isLoading ? <CmsCircularProgress/> : 
    <ContentWrapper>
      {/* Header */}
      <HomeTitle>Header Section</HomeTitle>
      {/* Table */}
      <CustomTable columns={columns} rows={rows} isLoading={isLoading}/>
      {/* Button Section */}
      <ButtonWrapper>
        <Link
          to={`/${partnerId}/aboutus`}
        >
          <Button className="m-0" variant="secondary">Go Back</Button>
        </Link>
        <Link
          to={`/${partnerId}/aboutus/header/edit/${id}`}
        >
          <Button className="m-0">{Number(id) ? 'Edit' : 'Add'} Header Section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
 </>
  );
}

const ContentWrapper = styled.div`
    @media (min-width:576px) {
    padding: 1rem;
    }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
     @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
  }
`;
